import styled from "styled-components";

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 0;
  max-width: max-content;

  label {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px;
  }

  select {
    padding: 8px 12px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    cursor: pointer;
    outline: none;
    transition: border-color 0.3s ease;

    &:hover {
      border-color: #007bff;
    }

    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
  }

  option {
    padding: 8px;
    font-size: 14px;
    color: #333;
  }
`;